module.exports = __webpack_public_path__ + "static/media/Welcome Kit.08dd91d2.svg";